import { Component, Input, OnChanges, SimpleChanges } from 'angular-ts-decorators';

import { fetchGroupPrice } from '@gn-audio/core';
import { IFromPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { IProductWithAttributes } from '@gn-audio/core/api/product-catalogue/models';

import template from './lowest-month-price.component.html';

@Component({
  selector: 'lowestMonthPrice',
  template,
})
export class LowestMonthPriceComponent implements OnChanges {
  @Input() public readonly group: IProductWithAttributes;

  public lowestMonthPriceFormatted?: string | null;
  public isDiscounted: boolean;

  public async ngOnChanges(changes: SimpleChanges<any>) {
    if (!changes.group?.currentValue) {
      return;
    }

    const groupPrice: IFromPrice | ISFCCGroupPrice | null = await fetchGroupPrice(this.group.groupId);
    if (!groupPrice) {
      this.isDiscounted = false;
      this.lowestMonthPriceFormatted = null;
      return;
    }

    this.isDiscounted = groupPrice.isDiscounted;
    this.lowestMonthPriceFormatted = (groupPrice as ISFCCGroupPrice).lowestPriceInLastMonthFormatted;
  }

  public get isLowestPriceShown() {
    return this.isDiscounted && !!this.lowestMonthPriceFormatted;
  }
}
